var map = {
	"./AFG.png": 6412,
	"./ALB.png": 5778,
	"./ALG.png": 5194,
	"./AND.png": 6599,
	"./ANG.png": 7350,
	"./ANT.png": 9935,
	"./ARG.png": 8810,
	"./ARM.png": 977,
	"./ARU.png": 4819,
	"./ASA.png": 5429,
	"./AUS.png": 5838,
	"./AUT.png": 1109,
	"./AZE.png": 8844,
	"./BAH.png": 2897,
	"./BAN.png": 2553,
	"./BAR.png": 8676,
	"./BDI.png": 2261,
	"./BEL.png": 7377,
	"./BEN.png": 5837,
	"./BER.png": 7508,
	"./BHU.png": 7538,
	"./BIH.png": 7665,
	"./BIZ.png": 7346,
	"./BLR.png": 3336,
	"./BOL.png": 6684,
	"./BOT.png": 9748,
	"./BRA.png": 5643,
	"./BRN.png": 2382,
	"./BRU.png": 1155,
	"./BUL.png": 4161,
	"./BUR.png": 856,
	"./CAF.png": 3338,
	"./CAM.png": 9130,
	"./CAN.png": 2952,
	"./CAY.png": 720,
	"./CHA.png": 2701,
	"./CHI.png": 456,
	"./CHN.png": 1451,
	"./CIS.png": 9563,
	"./CIV.png": 4675,
	"./CMR.png": 451,
	"./COK.png": 4727,
	"./COL.png": 4696,
	"./CPV.png": 4347,
	"./CRC.png": 613,
	"./CRO.png": 6642,
	"./CUB.png": 1570,
	"./CYP.png": 7462,
	"./CZE.png": 8973,
	"./DEN.png": 8630,
	"./DJI.png": 8068,
	"./DMA.png": 3497,
	"./DOM.png": 2699,
	"./ECU.png": 3464,
	"./EGY.png": 638,
	"./ENG.png": 598,
	"./ERI.png": 4417,
	"./ESA.png": 7997,
	"./ESP.png": 8000,
	"./EST.png": 7518,
	"./ETH.png": 957,
	"./FAO.png": 7950,
	"./FIJ.png": 6583,
	"./FIN.png": 6032,
	"./FIVB.png": 7404,
	"./FRA.png": 9280,
	"./GAB.png": 9215,
	"./GAM.png": 1366,
	"./GBR.png": 5212,
	"./GEO.png": 8091,
	"./GER.png": 359,
	"./GHA.png": 8522,
	"./GRE.png": 5845,
	"./GRN.png": 6210,
	"./GUA.png": 5698,
	"./GUI.png": 7826,
	"./GUM.png": 222,
	"./GUY.png": 9217,
	"./HAI.png": 5817,
	"./HKG.png": 2185,
	"./HON.png": 7415,
	"./HUN.png": 9895,
	"./IAEA.png": 2001,
	"./IHO.png": 3228,
	"./INA.png": 9437,
	"./IND.png": 6401,
	"./IRI.png": 2674,
	"./IRL.png": 4017,
	"./IRQ.png": 9987,
	"./ISL.png": 6789,
	"./ISR.png": 3538,
	"./ITA.png": 3386,
	"./IVB.png": 882,
	"./JAM.png": 7763,
	"./JOR.png": 87,
	"./JPN.png": 4208,
	"./KAZ.png": 7550,
	"./KEN.png": 3740,
	"./KGZ.png": 425,
	"./KIR.png": 9805,
	"./KOR.png": 3815,
	"./KSA.png": 6496,
	"./KUW.png": 5767,
	"./LAO.png": 5365,
	"./LAT.png": 6857,
	"./LBE.png": 3963,
	"./LCA.png": 6294,
	"./LES.png": 7336,
	"./LIB.png": 3909,
	"./LIE.png": 6296,
	"./LTU.png": 3255,
	"./LUX.png": 4141,
	"./MAD.png": 6230,
	"./MAR.png": 484,
	"./MAS.png": 2400,
	"./MAW.png": 8666,
	"./MDA.png": 8773,
	"./MDV.png": 6423,
	"./MEX.png": 341,
	"./MGL.png": 1312,
	"./MHL.png": 9038,
	"./MKD.png": 4898,
	"./MLI.png": 6334,
	"./MLT.png": 4127,
	"./MNE.png": 3030,
	"./MON.png": 3617,
	"./MOZ.png": 7602,
	"./MRI.png": 1331,
	"./MTN.png": 9697,
	"./MYA.png": 7235,
	"./NAM.png": 8635,
	"./NCA.png": 1104,
	"./NED.png": 7055,
	"./NEP.png": 3625,
	"./NGR.png": 8894,
	"./NIG.png": 8682,
	"./NOR.png": 8294,
	"./NRU.png": 2856,
	"./NZL.png": 6105,
	"./OAS.png": 9537,
	"./OMA.png": 2665,
	"./PAK.png": 6130,
	"./PAN.png": 3777,
	"./PAR.png": 5315,
	"./PER.png": 4532,
	"./PHI.png": 9496,
	"./PLE.png": 7485,
	"./PNG.png": 8708,
	"./POL.png": 6533,
	"./POR.png": 9969,
	"./PRK.png": 6217,
	"./PUR.png": 4318,
	"./QAT.png": 5134,
	"./ROU.png": 8289,
	"./RSA.png": 2032,
	"./RUS.png": 7119,
	"./RWA.png": 5327,
	"./SAM.png": 7135,
	"./SCO.png": 9958,
	"./SEN.png": 3213,
	"./SEY.png": 2649,
	"./SIN.png": 3710,
	"./SKN.png": 8840,
	"./SLE.png": 7669,
	"./SLO.png": 5479,
	"./SMR.png": 6437,
	"./SOL.png": 3465,
	"./SOM.png": 9721,
	"./SRB.png": 3273,
	"./SRI.png": 3105,
	"./SUD.png": 8857,
	"./SUI.png": 9838,
	"./SUR.png": 1623,
	"./SVK.png": 8271,
	"./SWE.png": 3244,
	"./SWZ.png": 3675,
	"./SYR.png": 7468,
	"./TAN.png": 4746,
	"./TGA.png": 2830,
	"./THA.png": 7234,
	"./TJK.png": 3975,
	"./TKM.png": 6626,
	"./TLS.png": 9996,
	"./TOG.png": 3298,
	"./TPE.png": 8756,
	"./TRI.png": 6971,
	"./TUN.png": 3246,
	"./TUR.png": 9676,
	"./TUV.png": 5375,
	"./UAE.png": 1743,
	"./UGA.png": 6731,
	"./UKR.png": 3850,
	"./UNK.png": 7275,
	"./URU.png": 1502,
	"./USA.png": 3254,
	"./UZB.png": 6870,
	"./VAN.png": 5494,
	"./VEN.png": 7765,
	"./VIE.png": 447,
	"./WAL.png": 82,
	"./WHO.png": 9321,
	"./WTO.png": 6205,
	"./YEM.png": 8594,
	"./ZAM.png": 8667,
	"./ZIM.png": 2079,
	"./oldUNK.png": 1734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8893;